export default "__VITE_ASSET__7D0jXhB6__"